/* Highlights.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives';
import { H5, Image, UserGeneratedHTML } from '@atlassian/mpac-primitives';
import { TEST_ID } from '../constants';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _23 = "._16jl1ohn{flex-grow:7}";
const _22 = "._1ul91pyr{min-width:31.5rem}";
const _21 = "@media not all and (min-width:48rem){._12b61osq{min-width:100%}._1rkb1osq{max-width:100%}}";
const _20 = "._4wztu2gc h3{margin-bottom:var(--ds-space-100,8px)}";
const _19 = "._apyeze3t p:last-of-type{margin-bottom:var(--ds-space-0,0)}";
const _18 = "._1ul9gew0{min-width:22.5rem}";
const _17 = "._16jlqfx8{flex-grow:5}";
const _16 = "._i0dlf1ug{flex-basis:0%}";
const _15 = "._1o9zkb7n{flex-shrink:1}";
const _14 = "._16jlkb7n{flex-grow:1}";
const _13 = "._b1p21sbv[data-order-reversed=true]{flex-direction:row-reverse}";
const _12 = "._1bsb1osq{width:100%}";
const _11 = "._1p57pxbi{row-gap:var(--ds-space-200,1pc)}";
const _10 = "._1bah1h6o{justify-content:center}";
const _9 = "._1n261g80{flex-wrap:wrap}";
const _8 = "._gy1pxy5q{column-gap:var(--ds-space-400,2pc)}";
const _7 = "._4cvr1h6o{align-items:center}";
const _6 = "@media (min-width:64rem){._pdlm1k7u{gap:3.5rem}._isu41k7u{margin-bottom:3.5rem}}";
const _5 = "@media (min-width:48rem) and (max-width:63.99rem){._1gzvoahv{gap:var(--ds-space-600,3pc)}._1b7eoahv{margin-bottom:var(--ds-space-600,3pc)}}";
const _4 = "._otyrxy5q{margin-bottom:var(--ds-space-400,2pc)}";
const _3 = "._2lx21bp4{flex-direction:column}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._zulpxy5q{gap:var(--ds-space-400,2pc)}";
export const Highlights = _ref => {
  let {
    highlights,
    onMediaItemClick
  } = _ref;
  if (!highlights.length) return null;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6]
    }), /*#__PURE__*/_jsx("section", {
      className: ax(["_zulpxy5q _1e0c1txw _2lx21bp4 _otyrxy5q _1gzvoahv _1b7eoahv _pdlm1k7u _isu41k7u"]),
      children: highlights.map((highlight, index) => /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_7, _8, _2, _9, _10, _11, _12, _13]
        }), /*#__PURE__*/_jsxs("div", {
          "data-order-reversed": index % 2 === 0,
          className: ax(["_4cvr1h6o _gy1pxy5q _1e0c1txw _1n261g80 _1bah1h6o _1p57pxbi _1bsb1osq _b1p21sbv"]),
          children: [/*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_14, _15, _16, _17, _18, _19, _20, _21]
            }), /*#__PURE__*/_jsxs("div", {
              className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _16jlqfx8 _1ul9gew0 _apyeze3t _4wztu2gc _12b61osq _1rkb1osq"]),
              children: [highlight.title && /*#__PURE__*/_jsx(H5, {
                as: HighlightHeadingLevel,
                children: highlight.title
              }), highlight.summary && /*#__PURE__*/_jsx(UserGeneratedHTML, {
                dangerousHTML: highlight.summary,
                "data-testid": TEST_ID.OVERVIEW_TAB_HIGHLIGHT_SUMMARY
              })]
            })]
          }), /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_14, _15, _16, _22, _23, _21]
            }), /*#__PURE__*/_jsx("div", {
              className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul91pyr _16jl1ohn _12b61osq _1rkb1osq"]),
              children: /*#__PURE__*/_jsx(Image, {
                width: "100%",
                height: "100%",
                aspectRatio: highlight.image.width / highlight.image.height,
                src: highlight.image.url,
                alt: highlight.image.altText || highlight.caption || '',
                onImageInteraction: () => onMediaItemClick({
                  dataURI: highlight.originalImage.url,
                  name: highlight.title || highlight.caption || 'Highlight'
                }),
                "data-testid": TEST_ID.OVERVIEW_TAB_HIGHLIGHT_IMAGE
              })
            })]
          })]
        }, "".concat(highlight.image.url, "-").concat(index))]
      }, "".concat(highlight.image.url, "-").concat(index)))
    })]
  });
};
const HighlightHeadingLevel = 'h3';
const Container = null;
const Row = null;
const HighlightContent = null;
const HighlightMedia = null;